export default "__VITE_ASSET__DMfYJqV0__"